module.exports = __webpack_public_path__ + "img/1584657230707555964.afe9a038.jpg";